import React, {Component} from 'react';
import axios from 'axios';
import cookie from 'react-cookies';
import OwlCarousel from 'react-owl-carousel';  
import 'owl.carousel/dist/assets/owl.carousel.css';  
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Navigation from './Navigation';
import Header from './Header';
import Footer from './Footer';
import Buysubscription from './Buysubscription';
import Buyxchange from './Buyxchange';
import Giftxchange from './Giftxchange';
import Modal from "react-bootstrap/Modal";
import 'bootstrap/dist/css/bootstrap.min.css';

import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

import '../App.css';

import Chinese from '../translations/cn';
import English from '../translations/en';
import Japanese from '../translations/jp';
import Korean from '../translations/ko';
import German from '../translations/ge';
import French from '../translations/fr';
import Spanish from '../translations/sp';
import Italian from '../translations/it';
import Russian from '../translations/ru';
import Portuguese from '../translations/po';
import Hindi from '../translations/hi';
import Arabic from '../translations/ar';

const stripePromise = loadStripe("pk_test_370qjoE9grb7T4nk8CH6kZyx00qUhUOKLR");

export const dictionaryList = {
	English,
	Chinese,
	Japanese,
	Korean,
	German,
	French,
	Spanish,
	Italian,
	Russian,
	Portuguese,
	Hindi,
	Arabic
};

class Store extends Component{
	constructor(props){
		super(props);

		this.state = {
			showBuySubscription: false,
			showBuyXchange: false,
			showGiftXchange: false,
			selectedGame: "url('assets/images/popular-game-main.jpg')",
			selectedGameTitle: "",
			gameList: [],
			gameSlides: null,
			gameSlides2: null,
			username: '',
			userAvatar: null,
			dataLanguage: dictionaryList['English'],
			totalPosts: 0,
			totalComments: 0,
			totalCharacters: 0,
			totalAssets: 0,
			xchangeAmount: 0,
			remaining_days: 0,
			assetNetworth: 0,
			characterNetworth: 0
		};

		this.getGameList();
	}
	
	componentWillMount(){
	}

	componentDidMount() {
		if ( localStorage.getItem('Language') ) {
			this.setState({
				dataLanguage: dictionaryList[localStorage.getItem('Language')]
			});
		} else {
			this.setState({
				dataLanguage: dictionaryList['English']
			});
		}

		this.setUserName();
		this.getPostCountData();
		this.getAssetNetworth();
		this.getCharacterNetworth();
	}

	getPostCountData() {
		if ( cookie.load('cookieId') ) {
			axios.get(window.$backend_url + '/getTotalPosts?userId=' + cookie.load('cookieId'))
				.then(response => {
					if ( response.status === 200 ) {
						this.setState({
							totalPosts: response.data
						});
					}
				})

			axios.get(window.$backend_url + '/getTotalComments?userId=' + cookie.load('cookieId'))
				.then(response => {
					if ( response.status === 200 ) {
						this.setState({
							totalComments: response.data
						});
					}
				})

			axios.get(window.$backend_url + '/getTotalCharacters?userId=' + cookie.load('cookieId'))
				.then(response => {
					if ( response.status === 200 ) {
						this.setState({
							totalCharacters: response.data
						});
					}
				})

			axios.get(window.$backend_url + '/getTotalAssets?userId=' + cookie.load('cookieId'))
				.then(response => {
					if ( response.status === 200 ) {
						this.setState({
							totalAssets: response.data
						});
					}
				})
		}
	}

	getAssetNetworth() {
		if ( cookie.load('cookieId') ) {
			axios.defaults.withCredentials = true;
			
			axios.get(window.$backend_url + '/getAssetNetworth?userId=' + cookie.load('cookieId'))
				.then(response => {
					if(response.status === 200){
						if (response.data[0].assetNetworth) {
							var symbol = '$';
							var price = parseFloat(response.data[0].assetNetworth);

							if (this.state.toCurrency) {
								symbol = this.state.toCurrency.symbol;
								price = parseFloat(price) * parseFloat(this.state.toCurrency.rate);
							}

							price = parseFloat(price.toFixed(2));

							this.setState({
								assetNetworth : symbol + price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
							})
						} else {
							this.setState({
								assetNetworth : '0'
							})
						}
					}
				})
		}
	}

	getCharacterNetworth() {
		if ( cookie.load('cookieId') ) {
			axios.defaults.withCredentials = true;
			
			axios.get(window.$backend_url + '/getCharacterListWithGameInfo?userId=' + cookie.load('cookieId'))
				.then(response => {
					if(response.status === 200){
						var characterNetworth = 0;

						for (var i=0; i<response.data.length; i++) {
							if (response.data[i].characterPrice) {
								characterNetworth += response.data[i].characterPrice;
							}
						}

						if ( characterNetworth ) {
							var symbol = '$';
							var price = parseFloat(characterNetworth);

							if (this.state.toCurrency) {
								symbol = this.state.toCurrency.symbol;
								price = parseFloat(price) * parseFloat(this.state.toCurrency.rate);
							}

							price = parseFloat(price.toFixed(2));

							this.setState({
								characterNetworth : symbol + price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
							})
						} else {
							this.setState({
								characterNetworth: '0'
							})
						}
					}
				})
		}
	}

	setUserName() {
		if ( cookie.load('cookieId') ) {
			const userdata = {
				userid: cookie.load('cookieId')
			}
			
			axios.defaults.withCredentials = true;
			
			axios.post(window.$backend_url + '/getUserInfo',userdata)
				.then(response => {
					if(response.status === 200){
						this.setState({
							username : response.data[0].first_name + " " + response.data[0].last_name,
							xchangeAmount: response.data[0].xchangeAmount
						})

                        if (response.data[0].role > 1) {
                            var targetDate = new Date(response.data[0].expire_date);
                            var currentDate = new Date();
                            var Difference_In_Time = targetDate.getTime() - currentDate.getTime(); 
                            var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24)); 

                            this.setState({
                                remaining_days: Difference_In_Days
                            })
                        }
					}
				})

			if (!this.state.userAvatar) {
				this.setUserAvatar();
			}
		}
	}

	setUserAvatar() {
		const userdata = {
			userid: cookie.load('cookieId')
		}		

		axios.defaults.withCredentials = true;
		
		axios.post(window.$backend_url + '/getUserAvatar', userdata)
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						userAvatar:  "url('" + response.data + "')"
					})
				} else {
					this.setState({
						userAvatar: "url('assets/images/profile-img.png')"
					})
				}

			})
			.catch(error => {
				this.setState({
					userAvatar: "url('assets/images/profile-img.png')"
				})

			})
	}

	getGameList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getGameList')
			.then(response => {				
				if ( response.status === 200 ) {
					this.setState(prevState  => ({
						gameList: response.data
					}));
					
					let slider1 = response.data.map((game, index) => {
						return(
							<div className="item" onClick={this.selectGame.bind(this)} rel={index}>
								//<img className="slide-image" alt={game.name} src={"assets/images/games/" + game.main_image} />
								// <div className="gameName">{game.name}</div>
								<img className="slide-image" alt={game.name} src="/assets/images/popular-game-main.jpg" />								
								<div className="gameName">{game.name}</div>
							</div>
						)
					});

					// this.setState({
					//	 gameSlides: slider1
					// });

					let obj0 = null;
					let obj1 = null;
					let obj2 = null;
					let obj3 = null;
					const gameCount = response.data.length;

					let slider2 = response.data.map((game, index) => {
						switch (index % 4){
							case 0:
								obj1 = null;
								obj2 = null;
								obj3 = null;
								obj0 = <div className="item" rel={index}><img className="slide-image" alt="" src={"assets/images/games/" + game.main_image} /><div className="gameName">{game.name}</div></div>;
								break;
							case 1:
								obj1 = <div className="item" rel={index}><img className="slide-image" alt="" src={"assets/images/games/" + game.main_image} /><div className="gameName">{game.name}</div></div>;
								break;
							case 2:
								obj2 = <div className="item" rel={index}><img className="slide-image" alt="" src={"assets/images/games/" + game.main_image} /><div className="gameName">{game.name}</div></div>;
								break;
							case 3:
								obj3 = <div className="item" rel={index}><img className="slide-image" alt="" src={"assets/images/games/" + game.main_image} /><div className="gameName">{game.name}</div></div>;
						}

						if (index % 4 === 3) {
							return(
									<div>{obj0}{obj1}{obj2}{obj3}</div>
								)
							
						} else if ( index === gameCount - 1) {
							return(
									<div>
										{obj0 ?
											obj0
										: null}
										{obj1 ?
											obj1
										: null}
										{obj2 ?
											obj2
										: null}
										{obj3 ?
											obj3
										: null}
									</div>
								)
						}
						
					});

					// this.setState({
					//	 gameSlides2: slider2
					// });
				}
			})
	}

	setLanguage(lang) {
		this.setState({
			dataLanguage: dictionaryList[lang]
		})
	}

	closeBuySubscription() {
		this.setUserName();
		this.toggleBuySubscription();
	}

	toggleBuySubscription() {
		this.setState({  
			showBuySubscription: !this.state.showBuySubscription  
		});
	}

	closeBuyXchange() {
		this.setUserName();
		this.toggleBuyXchange();
	}

	toggleBuyXchange() {
		this.setState({  
			showBuyXchange: !this.state.showBuyXchange  
		});
	}

	closeGiftXchange() {
		this.setUserName();
		this.toggleGiftXchange();
	}

	toggleGiftXchange() {
		this.setState({  
			showGiftXchange: !this.state.showGiftXchange  
		});
	}

	selectGame(e) {
		// this.setState({
		//	 selectedGame: "url('" + e.target.src + "')",
		//	 selectedGameTitle: e.target.alt
		// })
	}

	checkLogin() {
		if (cookie.load('cookieId')) {
			this.setState({
				isLogin: true
			})

			this.setUserName();
			this.getPostCountData()
			this.getAssetNetworth();
			this.getCharacterNetworth();
		} else {
			this.setState({
				isLogin: false
			})
		}
	}

	render(){
		const personStyle = {
			backgroundImage: this.state.userAvatar || "url('assets/images/profile-img.png')"
		};

		const selectedGameStyle = {
			backgroundImage: this.state.selectedGame || "url('assets/images/popular-game-main.jpg')"
		};

		const sliderOption = {
				loop: true,
				margin: 10,
				nav:true,
				responsive:{
					0: {
						items: 1,
						nav: false,
					},
					767: {
						items: 2,
					},
					1000: {
						items: 4,
					},
				}
			};

		const sliderOption2 = {
				loop: true,
				margin: 10,
				nav:true,
				responsive:{
					0: {
						items: 1,
						nav: false,
					},
					767: {
						items: 3,
					},
					1000: {
						items: 6,
					},
				}
			};
		
		return(
			<div className="digit store">
				<Header history={this.props.history} ref="header" dataLanguage={this.state.dataLanguage} setLanguage={this.setLanguage.bind(this)} checkLogin={this.checkLogin.bind(this)} />
				<div>
					<section className="banner">
						<div className="container">
							<Navigation active="6" dataLanguage={this.state.dataLanguage} history={this.props.history} header={this.refs.header} />
							<div className="banner-slider">
								<div className="owl-slider">
									<OwlCarousel items={1} className="owl-theme" margin={1} >
										<div><img alt="" className="img" src= {'assets/images/popular-game-main.jpg'}/></div>
									</OwlCarousel>
								</div>
							</div>
							{cookie.load('cookieId') ?
								<div className="person_info">
									<div className="row">
										<div className="col-md-3 col-12">
											<div className="back-avatar" style={personStyle}>
												<p className="user-name text-right">{this.state.username}</p>
											</div>
										</div>
										<div className="col-md-4 person_info_text_1">
											<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['total_posts']}:</span> <span className="text-counts">{this.state.totalPosts}</span></p></div>
											<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['total_comments']}:</span> <span className="text-counts">{this.state.totalComments}</span></p></div>
											<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['total_characters']}:</span> <span className="text-counts">{this.state.totalCharacters}</span></p></div>
											<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['total_assets']}:</span> <span className="text-counts">{this.state.totalAssets}</span></p></div>
										</div>
										{ this.state.isLogin ?
											<div className="col-md-5 person_info_text_2">
												<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['xchange_currency']}:</span> <span className="text-green">{this.state.xchangeAmount}</span></p></div>
												<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['subscription_days_remaining']}:</span> <span className="text-green">{this.state.remaining_days} {this.state.remaining_days > 1 ? this.state.dataLanguage['days'] : this.state.dataLanguage['day']}</span></p></div>
												<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['total_asset_networth']}:</span> <span className="text-green">{this.state.assetNetworth}</span></p></div>
												<div className="person_info_text"><p><span className="text-yellow">{this.state.dataLanguage['total_character_networth']}:</span> <span className="text-green">{this.state.characterNetworth}</span></p></div>
											</div>
										: null }
									</div>
								</div>
							: null} 
						</div>
					</section>
					
					<div className="main-area">
						<div className="container">
							{ cookie.load('cookieId') ? 
								<div className="post-create">
									<div className="row">
										<div className="col-md-4 col-sm-6 col-12">
											<button onClick={this.toggleBuySubscription.bind(this)}>{this.state.dataLanguage['buy']} <br /> {this.state.dataLanguage['subscription']}</button>
										</div>
										<div className="col-md-4 col-sm-6 col-12">
											<button onClick={this.toggleBuyXchange.bind(this)}>{this.state.dataLanguage['buy']} <br /> {this.state.dataLanguage['xchange']}</button>
										</div>
										<div className="col-md-4 col-12">
											<button onClick={this.toggleGiftXchange.bind(this)}>{this.state.dataLanguage['gift']} <br /> {this.state.dataLanguage['xchange']}</button>
										</div>
									</div>
								</div>
							: null }
							<div className="game-slider main-game-slider">
								<div className="owl-slider">
									<OwlCarousel className="owl-theme" {...sliderOption}>
										<div className="item">
											<img className="slide-image" alt="" src="/assets/images/popular-game-main.jpg" />
										</div>
										<div className="item">
											<img className="slide-image" alt="" src="/assets/images/popular-game-main.jpg" />
										</div>
										<div className="item">
											<img className="slide-image" alt="" src="/assets/images/popular-game-main.jpg" />
										</div>
										<div className="item">
											<img className="slide-image" alt="" src="/assets/images/popular-game-main.jpg" />
										</div>
										<div className="item">
											<img className="slide-image" alt="" src="/assets/images/popular-game-main.jpg" />
										</div>
										<div className="item">
											<img className="slide-image" alt="" src="/assets/images/popular-game-main.jpg" />
										</div>
										<div className="item">
											<img className="slide-image" alt="" src="/assets/images/popular-game-main.jpg" />
										</div>
										<div className="item">
											<img className="slide-image" alt="" src="/assets/images/popular-game-main.jpg" />
										</div>
										<div className="item">
											<img className="slide-image" alt="" src="/assets/images/popular-game-main.jpg" />
										</div>
										<div className="item">
											<img className="slide-image" alt="" src="/assets/images/popular-game-main.jpg" />
										</div>
									</OwlCarousel>
								</div>
							</div>
							<div className="search-container-out">
								<div className="search-container game-search">
									<form>
										<input name="search" placeholder={this.state.dataLanguage['search_games']} type="text" />
										<button type="submit"><img alt="" src="/assets/images/search-icon.png" /></button>
									</form>
								</div>
								<div className="alpahbet-buttons text-center">
									<button>{this.state.dataLanguage['all']}</button>
									<button>A</button>
									<button>B</button>
									<button>C</button>
									<button>D</button>
									<button>E</button>
									<button>F</button>
									<button>G</button>
									<button>H</button>
									<button>I</button>
									<button>J</button>
									<button>K</button>
									<button>L</button>
									<button>M</button>
									<button>N</button>
									<button>O</button>
									<button>P</button>
									<button>Q</button>
									<button>R</button>
									<button>S</button>
									<button>T</button>
									<button>U</button>
									<button>V</button>
									<button>W</button>
									<button>X</button>
									<button>Y</button>
									<button>Z</button>
								</div>
							</div>
							<div className="tab">
								<ul>
									<li className="clicked">{this.state.dataLanguage['trending']}</li>
									<li>{this.state.dataLanguage['most_downloaded']}</li>
									<li>{this.state.dataLanguage['recently_added']}</li>
									<li>{this.state.dataLanguage['genre']}</li>
								</ul>
							</div>
							<div className="selected-game">
								<div className="row">
									<div className="col-md-10 col-12 left">
										<div className="selected-game-image" style={selectedGameStyle}>
											{this.state.selectedGameTitle ?
												<div className="button-container">
													<div className="button-back">
														<div class="gameName flex">
															<p>{this.state.selectedGameTitle}</p>
															<button className="btn-yellow">{this.state.dataLanguage['buy']}</button>
															<button className="btn-yellow">{this.state.dataLanguage['view_demo']}</button>
														</div>
													</div>
												</div>
											: null}
										</div>
									</div>
									<div className="col-md-2 col-12 right">
										<div className="item" onClick={this.selectGame.bind(this)}>
											<img className="slide-image" alt="League of Legends" src="assets/images/popular-game-main.jpg" />
											<div className="gameName"></div>
										</div>
										<div className="item" onClick={this.selectGame.bind(this)}>
											<img className="slide-image" alt="PUBG" src="assets/images/popular-game-main.jpg" />
											<div className="gameName"></div>
										</div>
									</div>
								</div>
								<div className="game-slider">

									{this.state.gameSlides ?
										<div className="owl-slider">
											<OwlCarousel className="owl-theme" {...sliderOption2} >
												{this.state.gameSlides}
											</OwlCarousel>
										</div>
									: null }
								</div>
							</div>
							<div className="myLibrary">
								<h3 className="text-yellow text-center">{this.state.dataLanguage['my_library']}</h3>
								<div className="game-slider">
									{this.state.gameSlides2 ?
										<div className="owl-slider">
											<OwlCarousel className="owl-theme"  {...sliderOption} >
												{this.state.gameSlides2}
											</OwlCarousel>
										</div>
									: null }
									<div className="text-center">
										<img alt="" className="mylib_img" src= {'assets/images/popular-game-main.jpg'}/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{this.state.showBuySubscription ?  
					<Modal show={this.state.showBuySubscription} onHide={this.toggleBuySubscription.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<Elements stripe={stripePromise}>
							<Buysubscription dataLanguage={this.state.dataLanguage} closeBuySubscription={this.closeBuySubscription.bind(this)} xchangeAmount={this.state.xchangeAmount} />
						</Elements>
					</Modal>
				: null  
				}
				{this.state.showBuyXchange ?  
					<Modal show={this.state.showBuyXchange} onHide={this.toggleBuyXchange.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<Elements stripe={stripePromise}>
							<Buyxchange dataLanguage={this.state.dataLanguage} closeBuyXchange={this.closeBuyXchange.bind(this)} />
						</Elements>
					</Modal>
				: null  
				}
				{this.state.showGiftXchange ?  
					<Modal show={this.state.showGiftXchange} onHide={this.toggleGiftXchange.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<Giftxchange dataLanguage={this.state.dataLanguage} closeGiftXchange={this.closeGiftXchange.bind(this)} />
					</Modal>
				: null  
				}
				<Footer dataLanguage={this.state.dataLanguage} header={this.refs.header} />
			</div>
		)
	}
}

export default Store;


// WEBPACK FOOTER //
// ./src/components/Store.js